// CarouselSection.js
import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./CarouselSection.css";

export default function CarouselSection({
  slides,
  interval = 3000,
  showControls = true,
  showIndicators = true,
}) {
  return (
    <Carousel controls={showControls} indicators={showIndicators} interval={interval}>
      {slides.map((s, i) => (
        <Carousel.Item key={i}>
          <img className="d-block w-100 carousel-image" src={s.image} alt={s.title} />
          <Carousel.Caption>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
            <span className="slide-counter">{i + 1} / {slides.length}</span>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
